const PREVIEWABLE_EXTENSIONS = new Set(['pdf', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'txt']);
const NON_PREVIEWABLE_EXTENSIONS = new Set(['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip', 'rar', '7z']);

export const getDocumentExtension = (name = '') => {
  const cleanName = String(name).split('?')[0].split('#')[0];
  const parts = cleanName.split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

export const isPreviewableDocument = (name, contentType = '') => {
  const ext = getDocumentExtension(name);
  // Extension takes precedence — backend MIME may not reflect the real file type
  if (NON_PREVIEWABLE_EXTENSIONS.has(ext)) return false;
  if (PREVIEWABLE_EXTENSIONS.has(ext)) return true;
  const mime = String(contentType || '').toLowerCase();
  return mime.includes('pdf') || mime.startsWith('image/') || mime.startsWith('text/');
};

export const buildDocumentPreviewError = (status) => {
  if (status === 404) return 'Document was not found in storage. It may have been moved or removed.';
  if (status === 401 || status === 403) return 'You do not have permission to preview this document.';
  return 'Document preview could not be loaded. You can still try downloading the original file.';
};
